<template>
  <v-dialog v-model="dialog" persistent width="500">
    <v-form @submit.prevent="handleSubmit">
      <v-card :disabled="loading">
        <v-card-title>
          {{ __("formulário tipos equipamentos") }}
          <v-spacer></v-spacer>
          <v-btn @click="close()" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="form.name"
            :label="__('Nome')"
            autofocus
            outlined
          ></v-text-field>
          <SelectProductLine
            v-model="form.product_line_id"
            label="Linha de produto"
          />
          <v-combobox
            v-model="form.aliases"
            label="Tags"
            small-chips
            multiple
            outlined
          ></v-combobox>
          <v-switch
            v-model="form.can_search_ean"
            label="Autoidentificar EAN"
            inset
            hint="Quando o EAN não for informado, a inteligência artificial tentará identificá-lo automaticamente"
            persistent-hint
          >
          </v-switch>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close()" text> {{ __("cancelar") }} </v-btn>
          <v-btn type="submit" color="primary" dark :loading="loading">
            {{ __("Salvar") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { store, update } from "@/services/product_types.js";
import ToastsMixin from "@/mixins/ToastsMixin.vue";
import i18n from "@/mixins/i18n";
import SelectProductLine from "@/components/Products/SelectProductLine.vue";

export default {
  mixins: [ToastsMixin, i18n],
  components: {
    SelectProductLine,
  },

  data() {
    return {
      i18n_prefix: "settings",
      dialog: false,
      loading: false,
      form: {
        name: "",
        product_line_id: null,
      },
    };
  },

  methods: {
    open() {
      this.dialog = true;
      this.resetForm();
    },

    openForUpdate(data) {
      this.form = {
        ...data,
      };
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    resetForm() {
      this.form = {
        name: "",
        product_line_id: null,
      };
    },

    async handleCreate() {
      this.loading = true;

      try {
        const response = await store(this.form);

        this.$emit("submitted", response);
        this.close();
        this.toast(this.__("tipo registado com sucesso", "settings"));
      } catch (error) {
        console.error(error);
        if (error.response?.status === 400) {
          this.toastError(error.response.data.message);
          return;
        }
        this.toastError(this.__("Não foi possível registar", "settings"));
      } finally {
        this.loading = false;
      }
    },

    async handleUpdate() {
      this.loading = true;

      try {
        const response = await update(this.form.id, this.form);

        this.$emit("submitted", response);
        this.close();
        this.toast(this.__("tipo atualizado com sucesso", "settings"));
      } catch (error) {
        console.error(error);
        if (error.response?.status === 400) {
          this.toastError(error.response.data.message);
          return;
        }
        this.toastError(this.__("Não foi possível registar", "settings"));
      } finally {
        this.loading = false;
      }
    },

    handleSubmit() {
      if (this.form.id) {
        this.handleUpdate();
      } else {
        this.handleCreate();
      }
    },
  },
};
</script>
